import React from "react";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Stack from "@mui/material/Stack";
import Collapse from "@mui/material/Collapse";
import Typography from "@mui/material/Typography";

import QrCode from "pages/Invoices/InvoiceQRCodeModal/QrCode";
import { QR_ELEMENT_ID } from "pages/Invoices/InvoiceQRCodeModal/constants";

import { invoiceTabs, InvoiceTabId } from "..";

import { useQrDownloader } from "hooks/useQrDownloader";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { styles } from "../styles";

interface InvoiceTabsProps {
  invoiceUrl?: string | null;
  visibleTab?: InvoiceTabId;
  setVisibleTab?: (tabId: InvoiceTabId) => void;
}

export const InvoiceTabs: React.FC<InvoiceTabsProps> = (props) => {
  const { invoiceUrl, visibleTab, setVisibleTab } = props;

  const fileName = `ibanoplata-qr-${new Date().toISOString().slice(0, 10)}.png`;

  const { downloadQrAsPng } = useQrDownloader();

  const handleTabChange = (_: React.SyntheticEvent, newValue: InvoiceTabId) => {
    setVisibleTab && setVisibleTab(newValue);
  };

  const handleQrDownload = async () => {
    if (invoiceUrl) {
      analytics().sendConversionEvent(
        AnalyticsEvents.qrcode_invoice_install_ + "tabs",
        null,
        true,
      );
      await downloadQrAsPng(QR_ELEMENT_ID, fileName);
    }
  };

  return (
    <Stack sx={{ width: "100%" }} spacing={2} alignItems="center">
      <Tabs value={visibleTab} onChange={handleTabChange}>
        {invoiceTabs.map((tab) => (
          <Tab
            sx={{ p: "4px 16px", "&.Mui-selected": { color: "grey900" } }}
            key={tab.id}
            value={tab.id}
            label={tab.label}
            data-testid={`invoice-tab-${tab.id}`}
          />
        ))}
      </Tabs>

      <Stack sx={{ width: "100%" }} alignItems="center">
        <Collapse in={visibleTab === InvoiceTabId.QrCode}>
          <Box sx={styles.qrContainer} onClick={handleQrDownload}>
            <QrCode invoiceUrl={invoiceUrl || ""} />
            <Typography variant="body2" color="grey800" sx={{ mt: 1 }}>
              Натисніть на QR для завантаження
            </Typography>
          </Box>
        </Collapse>

        <Collapse
          in={visibleTab === InvoiceTabId.Message}
          sx={{ width: "100%" }}
        >
          <Box sx={styles.urlWrapper}>
            <Typography noWrap>{invoiceUrl}</Typography>
          </Box>
        </Collapse>
      </Stack>
    </Stack>
  );
};
